import { render } from "./QuizCard.vue?vue&type=template&id=7facd07f&ts=true"
import script from "./QuizCard.vue?vue&type=script&lang=ts"
export * from "./QuizCard.vue?vue&type=script&lang=ts"

import "./QuizCard.vue?vue&type=style&index=0&id=7facd07f&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__